import Controller from "./routePlanning.controller";
import template from "./routePlanning.html";

const routePlanning = {
  template,
  controller: Controller,
};

export default routePlanning;



// WEBPACK FOOTER //
// ./src/pages/routePlanning/routePlanning.component.js